import PromiseQueue from '@/lib/async/PromiseQueue'
import Watchable from '@/mixins/watchable'
import CartData from '@/mixins/pos/cartData'
import AddressCommon from '@/mixins/maps/addressCommon'
import FiscalDocTypeEnum from '@/api/Enums/FiscalDocTypeEnum'
import FiscalDocsProviderTypeEnum from '@/api/Enums/FiscalDocsProviderTypeEnum'
import {clone, emailIsGuest} from '@/lib/helper/helper'
import {isBoolean} from '@/lib/data/Validations/utils/Utils'
import * as SocketTableHelper from '@/api/SocketTableHelper.js'

export default {
  data() {
    return {
      isCartInitialized: false,
      promiseQueue     : null,
      cdsChannel       : new BroadcastChannel('cds')
    }
  },

  computed: {},

  mixins: [Watchable, CartData, AddressCommon],

  watch: {},

  created() {
    this.promiseQueue = new PromiseQueue({
      concurrency: 1,
      cooldown   : 0
    })

    this.$bus.$on('cart:cart-update', this.cartUpdate)

    this.$bus.$on(window.SocketCommand.Cart.Init, this.onCartInit)
    this.$bus.$on(window.SocketCommand.Cart.Update, this.onCartUpdate)
    this.$bus.$on(window.SocketCommand.Cart.Destroy, this.onCartDestroy)

    this.$bus.$on('cart:cart-add-item', this.cartAddItem)
    this.$bus.$on('cart:cart-update-item', this.cartUpdateItem)
    this.$bus.$on(window.SocketCommand.Cart.Item.Add, this.onCartAddItem)
    this.$bus.$on(window.SocketCommand.Cart.Item.Remove, this.onCartRemoveItem)
    this.$bus.$on(window.SocketCommand.Cart.Item.Update, this.onCartUpdateItem)

    this.$bus.$on('cart:cart-add-transaction', this.cartAddTransaction)
    this.$bus.$on('cart:cart-remove-transaction', this.cartRemoveTransaction)

    this.$bus.$on(window.SocketCommand.Cart.Coupon.Add, this.onCartAddCoupon)
    this.$bus.$on(window.SocketCommand.Cart.Coupon.Remove, this.onCartRemoveCoupon)

    this.$bus.$on(window.SocketCommand.Cart.Tip.Add, this.onCartAddTip)
    this.$bus.$on(window.SocketCommand.Cart.Tip.Remove, this.onCartRemoveTip)

    this.$bus.$on(window.SocketCommand.Cart.ExtraCharge.Add, this.onCartAddExtraCharge)
    this.$bus.$on(window.SocketCommand.Cart.ExtraCharge.Remove, this.onCartRemoveExtraCharge)
    this.$bus.$on(window.SocketCommand.Cart.ExtraCharge.Delete, this.onCartDeleteExtraCharge)

    this.$bus.$on(window.SocketCommand.Cart.Order.Complete, this.onCartOrderComplete)

    this.$bus.$on(window.SocketCommand.Table.Cart.Complete, this.onTableOrderComplete)

    this.$bus.$on(window.SocketCommand.Cart.Scheduled.Update, this.onCartUpdateScheduled)

    this.$bus.$on('cds:send-message', this.cdsChannelMessageSend)

    this.$bus.$on('cart:init-voip-order', this.initCartParams)

    this.cdsChannel.onmessage = this.cdsChannelMessageReceived

    this.cartInit()
  },

  beforeDestroy() {
    this.$bus.$off('cart:cart-update', this.cartUpdate)

    this.$bus.$off(window.SocketCommand.Cart.Init, this.onCartInit)
    this.$bus.$off(window.SocketCommand.Cart.Update, this.onCartUpdate)
    this.$bus.$off(window.SocketCommand.Cart.Destroy, this.onCartDestroy)

    this.$bus.$off('cart:cart-add-item', this.cartAddItem)
    this.$bus.$off('cart:cart-update-item', this.cartUpdateItem)
    this.$bus.$off(window.SocketCommand.Cart.Item.Add, this.onCartAddItem)
    this.$bus.$off(window.SocketCommand.Cart.Item.Remove, this.onCartRemoveItem)
    this.$bus.$off(window.SocketCommand.Cart.Item.Update, this.onCartUpdateItem)

    this.$bus.$off('cart:cart-add-transaction', this.cartAddTransaction)
    this.$bus.$off('cart:cart-remove-transaction', this.cartRemoveTransaction)

    this.$bus.$off(window.SocketCommand.Cart.Coupon.Add, this.onCartAddCoupon)
    this.$bus.$off(window.SocketCommand.Cart.Coupon.Remove, this.onCartRemoveCoupon)

    this.$bus.$off(window.SocketCommand.Cart.Tip.Add, this.onCartAddTip)
    this.$bus.$off(window.SocketCommand.Cart.Tip.Remove, this.onCartRemoveTip)

    this.$bus.$off(window.SocketCommand.Cart.ExtraCharge.Add, this.onCartAddExtraCharge)
    this.$bus.$off(window.SocketCommand.Cart.ExtraCharge.Remove, this.onCartRemoveExtraCharge)
    this.$bus.$off(window.SocketCommand.Cart.ExtraCharge.Delete, this.onCartDeleteExtraCharge)

    this.$bus.$off(window.SocketCommand.Cart.Order.Complete, this.onCartOrderComplete)

    this.$bus.$off(window.SocketCommand.Table.Cart.Complete, this.onTableOrderComplete)

    this.$bus.$off('cds:send-message', this.cdsChannelMessageSend)

    this.$bus.$off('cart:init-voip-order', this.initCartParams)

    this.clearData()
    this.promiseQueue = null

    this.cdsChannel.close()
  },

  methods: {
    cartInit() {
      this.initCartParams(this.$route.params)

      if (this.orderId > 0) {
        this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.Init, {
          CartId: this.orderId
        }))
      } else {
        const cartData = this.posCart.clone()
        this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.Init, {
          Cart   : cartData,
          TableId: this.tableId || null,
          CartId : null
        }))
      }
    },

    initCartParams(params) {
      if (params?.hasOwnProperty('callerID') && !isNaN(params?.callerID)) {
        this.posCart.SourceTypeId = this.appConfig.SOURCE_TYPES.DEFAULT.VOIP.source_type_id
        if (!params?.hasOwnProperty('customerId')) {
          this.showCustomerSearchDialog(params?.callerID)
        }
      }

      if (params?.hasOwnProperty('customerId') && params?.customerId) {
        this.posCart.CustomerId = params?.customerId
      }

      if (this.appConfig.LOCATION_DATA.hasOwnProperty('DefaultOrderTypePos') &&
        this.appConfig.LOCATION_DATA.DefaultOrderTypePos &&
        !params?.hasOwnProperty('isFromCopy')) {
        this.posCart.OrderType = this.appConfig.LOCATION_DATA.DefaultOrderTypePos
      }

      if (params?.hasOwnProperty('orderType') && params?.orderType) {
        this.posCart.OrderType = parseInt(params?.orderType || '1')
      }

      if (params?.hasOwnProperty('isFromCopy') && params?.hasOwnProperty('isDeleteAndCopyOrder')) {
        if (params?.isFromCopy === true && params?.isDeleteAndCopyOrder === false) {
          this.posCart.SourceTypeId = this.appConfig.SOURCE_TYPES.DEFAULT.POS.source_type_id
        }
      }
    },

    onCartInit(data) {
      if (data && !data.hasOwnProperty('error')) {
        this.cartSetData(data)

        if (!this.orderId) {
          this.$router.replace({
            name  : this.$route.name,
            params: {
              ...this.$route.params,
              orderId: data.Id
            }
          })
        }

        this.checkForCustomerAddress()

        this.$bus.$emit('cart:init', data)

        this.cdsChannelMessageSend({
          Action : 'cart:init',
          Payload: data
        })

        this.isCartInitialized = true
      } else {
        this.isOrderComplete = true
        this.$router.replace({name: 'OrdersSaved'})
      }
    },

    async cartUpdate(event) {
      if (!this.isCartInitialized) return

      // console.log('----- CART UPDATE: ', event)

      const cartData = this.posCart.clone()

      if (event === 'selectedAddress') await this.validateCustomerAddress()

      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.Update, {
        Cart: {
          CustomerId                : cartData.CustomerId,
          SCustomer                 : cartData.SCustomer,
          AddressId                 : cartData.AddressId,
          SAddress                  : cartData.SAddress,
          Comment                   : cartData.Comment,
          SOrderType                : cartData.SOrderType,
          SourceTypeId              : cartData.SourceTypeId,
          OrderTypeTime             : cartData.OrderTypeTime,
          ScheduledOrder            : cartData.ScheduledOrder,
          PaymentType               : cartData.PaymentType,
          RespectDeliveryAreaCharges: cartData.RespectDeliveryAreaCharges
        },
        CartId      : cartData.Id,
        Exit        : event === 'saveOrderEdit' ? 1 : 0,
        ExtraCharges: (event === 'selectedAddress' || event === 'orderType' || event === 'orderTypeTime' || event === 'removeDeliveryAreaCharges')
      }))
    },

    onCartUpdate(data) {
      this.cartSetData(data)

      if (parseInt(this.posCart.AddressId) <= 0 || !this.posCart.Address) {
        this.checkForCustomerAddress()
      }
    },

    async validateCustomerAddress() {
      if (this.selectedAddress) {
        const result = await this.isPlaceInsideDeliveryAreas(this.addressToPlaceObject(this.selectedAddress))
        this.addressIsOutsideStoreLimits = !result
      }
      this.posCart.RespectDeliveryAreaCharges = true
    },

    cartDestroy() {
      if (!this.isCartInitialized) return
      this.promiseQueue.clear()
      window.callAS(window.SocketCommand.Cart.Destroy, {CartId: this.posCart.Id})
    },
    onCartDestroy(data) {
      this.cdsChannelMessageSend({
        Action : 'cart:destroy',
        Payload: null
      })

      if (data) {
        this.isOrderComplete = true
        if (this.routeNext) {
          this.routeNext()
        } else {
          if (this.tableId > 0) {
            this.$router.replace({name: 'Tables'})
          } else {
            if (this.userIsWaiter) {
              if (this.posUserCan('Orders', 'ACCESS')) {
                this.$router.replace({name: 'OrdersToday'})
              } else {
                this.$router.replace({name: 'Tables'})
              }
            } else {
              this.$router.replace({name: 'OrdersToday'})
            }
          }
        }
      } else {
        this.$bus.$emit('app-show-notification', {
          body   : this.$t('Pos.Pos.Notification.Cancel'),
          timeout: 2000,
          type   : 'error',
          icon   : 'warning'
        })

        if (this.routeNext) this.routeNext(false)
      }
    },

    cartAddItem(menuItem) {
      if (!this.isCartInitialized) return
      const cartData = this.posCart.clone()
      const menuData = JSON.parse(JSON.stringify(menuItem))
      if (menuData?.Details?.OptionsCopy) delete menuData.Details.OptionsCopy

      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.Item.Add, {
        CartId  : cartData.Id,
        MenuItem: {
          RowId       : menuData.Details.RowId,
          Custom      : menuData.Details.Custom,
          Id          : menuData.Details.Id,
          Comment     : menuData.Details.Comment,
          Options     : menuData.Details.Options,
          OptionValues: this.getMenuItemSelectedOptionValueIds(menuData),
          Quantity    : menuData.Quantity,
          UnitQuantity: menuData.UnitQuantity || 1,
          UnitId      : menuData.UnitId || 1,
          Price       : menuData.HasCustomPrice ? menuData.Price : null
        }
      }))
    },
    onCartAddItem(data) {
      this.cartSetData(data)
    },

    cartRemoveItem(menuItem) {
      if (!this.isCartInitialized || !menuItem?.RowId) return
      const cartData = this.posCart.clone()

      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.Item.Remove, {
        CartId: cartData.Id,
        RowId : menuItem.RowId
      }))
    },
    onCartRemoveItem(data) {
      this.cartSetData(data)
    },

    cartUpdateItem(menuItem) {
      if (!this.isCartInitialized || !menuItem) return
      const cartData = this.posCart.clone()
      const menuData = clone(menuItem)
      if (menuData?.Details?.OptionsCopy) delete menuData.Details.OptionsCopy
      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.Item.Update, {
        CartId  : cartData.Id,
        MenuItem: {
          RowId         : menuData.Details.RowId || menuData.RowId,
          Custom        : menuData.Details.Custom || menuData.Custom,
          Id            : menuData.Details.Id || menuData.Id,
          Comment       : menuData.Details.Comment || menuData.Comment,
          Options       : menuData.Details.Options || menuData.Options,
          PriorityCustom: menuData.PriorityCustom,
          OptionValues  : this.getMenuItemSelectedOptionValueIds(menuData),
          Quantity      : menuData.Quantity,
          UnitQuantity  : menuData.UnitQuantity || 1,
          UnitId        : menuData.UnitId || 1,
          Price         : menuData.HasCustomPrice ? menuData.Price : null
        }
      }))
    },
    onCartUpdateItem(data) {
      this.cartSetData(data)
      this.menuOptionsDialogVisible = false
    },

    cartAddCoupon(coupon) {
      if (!this.isCartInitialized || !coupon) return
      const cartData = this.posCart.clone()
      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.Coupon.Add, {
        CartId: cartData.Id,
        Coupon: coupon
      }))
    },
    onCartAddCoupon(data, payload) {
      // console.log('>>>>>>> onCartAddCoupon', data, payload)
      const rowId = data?.Payload?.RowId || data?.Payload?.rowid || payload?.Coupon?.RowId || payload?.Coupon?.rowid
      const cartItem = this.getCartItemByRowId(rowId)
      if (cartItem) {
        this.$set(cartItem, 'Loading', false)
        this.$set(cartItem, 'LoadingCoupon', false)
      } else {
        this.$set(this, 'loadingAddCoupon', false)
      }

      this.cartSetData(data)
    },

    cartAddTip(tip) {
      if (!this.isCartInitialized || !tip) return
      const cartData = this.posCart.clone()
      this.loadingAddTip = true
      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.Tip.Add, {
        CartId   : cartData.Id,
        TipAmount: tip
      }))
    },
    onCartAddTip(data) {
      this.cartSetData(data)
      this.selectTipDialogVisible = false
      this.loadingAddTip = false
    },

    cartUpdateScheduled(scheduledOrder) {
      if (!this.isCartInitialized || !scheduledOrder) return
      const cartData = this.posCart.clone()
      this.scheduledLoading = true
      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.Scheduled.Update, {
        CartId   : cartData.Id,
        Scheduled: scheduledOrder
      }))
    },
    onCartUpdateScheduled(data) {
      this.cartSetData(data)
      this.scheduledLoading = false
    },

    cartIncrementExtraCharge(extraCharge, incrementQuantity) {
      if (!this.isCartInitialized || !extraCharge) return
      const cartData = this.posCart.clone()
      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.ExtraCharge.Add, {
        CartId           : cartData.Id,
        Charge           : extraCharge,
        IncrementQuantity: incrementQuantity || 1
      }))
    },

    cartAddExtraCharge(extraCharge) {
      if (!this.isCartInitialized || !extraCharge) return
      const cartData = this.posCart.clone()
      this.loadingAddExtraCharge = true
      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.ExtraCharge.Add, {
        CartId: cartData.Id,
        Charge: extraCharge
      }))
    },
    onCartAddExtraCharge(data) {
      this.cartSetData(data)
      this.selectExtraChargeDialogVisible = false
      this.loadingAddExtraCharge = false
    },

    cartAddTransaction(payload) {
      if (!this.isCartInitialized || !payload) return
      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Order.Payment.Transaction.Add, payload))
    },
    onCartAddTransaction(data) {
    },

    cartRemoveTransaction(payload) {
      if (!this.isCartInitialized || !payload) return
      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Order.Payment.Transaction.Remove, payload))
    },
    onCartRemoveTransaction(data) {
      //TODO
    },

    removeDeliveryAreaCharges() {
      this.posCart.RespectDeliveryAreaCharges = false
      this.cartUpdate('removeDeliveryAreaCharges')
    },

    cartRemoveCoupon(coupon) {
      if (!this.isCartInitialized || !coupon) return
      const cartData = this.posCart.clone()
      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.Coupon.Remove, {
        CartId: cartData.Id,
        Coupon: coupon
      }))
    },
    onCartRemoveCoupon(data, payload) {
      // console.log('>>>>>>> onCartRemoveCoupon', data, payload)
      const rowId = data?.Payload?.RowId || payload?.Coupon?.RowId
      const code = data?.Payload?.Code || payload?.Coupon?.Code
      const menuItem = this.getCartItemByRowId(rowId)
      const couponItem = this.getCartCouponByCode(code)

      if (menuItem) {
        this.$set(menuItem, 'Loading', false)
        this.$set(menuItem, 'LoadingCoupon', false)
      }

      if (couponItem) {
        this.$set(couponItem, 'Loading', false)
      }

      this.cartSetData(data)
    },

    cartDecrementExtraCharge(extraCharge, decrementQuantity) {
      if (!this.isCartInitialized || !extraCharge) return
      const cartData = this.posCart.clone()
      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.ExtraCharge.Remove, {
        CartId           : cartData.Id,
        Charge           : extraCharge,
        DecrementQuantity: decrementQuantity || 1
      }))
    },
    onCartRemoveExtraCharge(data) {
      this.cartSetData(data)
    },

    cartDeleteExtraCharge(extraCharge) {
      if (!this.isCartInitialized || !extraCharge) return
      this.loadingDeleteExtraCharge = true
      const cartData = this.posCart.clone()
      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.ExtraCharge.Delete, {
        CartId: cartData.Id,
        Charge: extraCharge
      }))
    },
    onCartDeleteExtraCharge(data) {
      this.loadingDeleteExtraCharge = false
      this.cartSetData(data)
    },

    cartRemoveTip(tip) {
      if (!this.isCartInitialized || !tip) return
      this.loadingRemoveTip = true
      const cartData = this.posCart.clone()
      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.Tip.Remove, {
        CartId   : cartData.Id,
        TipAmount: tip.Amount
      }))
    },
    onCartRemoveTip(data) {
      this.loadingRemoveTip = false
      this.cartSetData(data)
    },

    tableOrderComplete(data) {
      const cart = this.posCart.clone()
      const cartId = cart?.Id || null
      const tableId = cart?.TableShift?.TableId || null
      const autoPrint = data?.autoPrint ?? true
      if (!cart || !cartId || !tableId) return

      const requestData = {
        TableId: tableId,
        CartId : cartId,
        Cart   : {
          Id                        : cart.Id,
          TableShiftId              : cart.TableShiftId,
          CustomerId                : cart.CustomerId,
          SCustomer                 : cart.SCustomer,
          SAddress                  : cart.SAddress,
          AddressId                 : cart.AddressId,
          Comment                   : cart.Comment,
          SOrderType                : cart.SOrderType,
          SourceTypeId              : cart.SourceTypeId,
          OrderTypeTime             : cart.OrderTypeTime,
          PaymentType               : cart.PaymentType,
          RespectDeliveryAreaCharges: cart.RespectDeliveryAreaCharges
        },
        AutoPrint: autoPrint,
        Exit     : true
      }

      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Table.Cart.Complete, requestData))
    },
    onTableOrderComplete(data, payload) {
      if (data.status === 'success') {
        this.isOrderComplete = true
        this.$router.replace({name: 'Tables'})
        this.$bus.$emit('app-show-notification', {
          body   : this.$t('Pos.Pos.Notification.Complete'),
          timeout: 2000,
          type   : 'success',
          icon   : 'check_circle'
        })
      } else {
        this.completeOrderButtonEnabled = true
        this.$bus.$emit('app-show-notification', {
          body   : this.$t('Common.Error.Generic'),
          type   : 'error',
          icon   : 'warning',
          timeout: 3000
        })
        SocketTableHelper.getTable(payload?.TableId)
      }
    },

    cartOrderComplete(data) {
      if (!this.isCartInitialized) return
      const cartData = this.posCart.clone()

      const autoPrint = data?.autoPrint ?? true
      const docType = data?.receiptType || FiscalDocTypeEnum.RECEIPT
      const company = data?.receiptData || null
      const printNotify = data?.printNotify ?? null
      const emailNotify = data?.emailNotify ?? null
      const appSupportsReceipts = this.appHasFiscalDocsProvider && (this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.CLOUD || this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.LOCAL)
      const customerEmail = emailNotify && this.posCart?.CustomerId && this.posCart?.SCustomer?.Email ? [this.posCart.SCustomer.Email] : []
      const dataEmails = data?.emailAddresses || []
      const emailAddresses = [...new Set([...customerEmail, ...dataEmails])].filter(email => !emailIsGuest(email))

      const receiptData = {
        DocType       : docType,
        Print         : printNotify,
        Email         : emailNotify,
        EmailAddresses: emailAddresses,
        Company       : company
      }

      const requestData = {
        CartId        : cartData.Id,
        AutoPrint     : autoPrint,
        IsFullDiscount: data?.isFullDiscount ?? false,
        ...(appSupportsReceipts && receiptData)
      }

      this.promiseQueue.push(() => window.callAS(window.SocketCommand.Cart.Order.Complete, requestData))
    },
    onCartOrderComplete(data) {
      if (!data || data.hasOwnProperty('error')) {
        this.completeOrderButtonEnabled = true

        this.$bus.$emit('app-show-notification', {
          body   : data.message ? data.message : this.$t('Pos.Pos.Notification.Error'),
          timeout: 2000,
          type   : 'error',
          icon   : 'warning'
        })
        return
      }

      this.isOrderComplete = true
      this.$router.replace({name: 'OrdersToday'})

      this.$bus.$emit('app-show-notification', {
        body   : this.$t('Pos.Pos.Notification.Complete'),
        timeout: 2000,
        type   : 'success',
        icon   : 'check_circle'
      })

      this.cdsChannelMessageSend({
        Action : 'cart:complete',
        Payload: null
      })

      this.handleRouteChange()
    },

    handleRouteChange() {
      // Stay in Pos Screen After Each Order if Enabled
      const stayInPosEnabled = this.appConfig?.LOCATION_DATA?.StayInPos?.Enabled || false

      if (stayInPosEnabled) {
        const override = this.appConfig?.LOCATION_DATA?.StayInPos?.Override || 'machine'
        const machines = this.appConfig?.LOCATION_DATA?.StayInPos?.Machines || []
        const users = this.appConfig?.LOCATION_DATA?.StayInPos?.Users || []
        const machineStayInPos = machines.includes(this.$DataStore.app.guid)
        const userStayInPos = users.includes(this.posUser.staff_id)
        const stayInPos = machineStayInPos || userStayInPos

        if (override === 'machine' && machineStayInPos) {
          this.stayInPosRoute()
          return
        }

        if (override === 'user' && userStayInPos) {
          this.stayInPosRoute()
          return
        }

        if (stayInPos) this.stayInPosRoute()
      }
    },

    stayInPosRoute() {
      this.$nextTick(() => {
        this.$router.replace({name: 'Pos'})
      })
    },

    cartSetData(data) {
      if (!data || data.hasOwnProperty('error') || isBoolean(data)) {
        this.$bus.$emit('app-show-notification', {
          body   : data.message ? data.message : this.$t('Pos.Pos.Notification.Error'),
          timeout: 2000,
          type   : 'error',
          icon   : 'warning'
        })

        if (data?.payload) {
          const cartItem = this.getCartItemByRowId(data?.payload?.RowId)
          if (cartItem) {
            this.$set(cartItem, 'Loading', false)
            this.$set(cartItem, 'LoadingRemove', false)
            this.$set(cartItem, 'LoadingCoupon', false)
          }
        }

        return
      }

      if (this.isTableOrder) {
        this.$bus.$emit('toolbar-update-title', `${this.tableTitle} - ${this.title}`)
      } else {
        this.$bus.$emit('toolbar-update-title', `${this.title} #${data.Id}`)
      }

      data = this.setLoaders(clone(data))

      const menuItems = (data?.Items || []).sort((a, b) => parseInt(b.PriorityCustom) - parseInt(a.PriorityCustom))
      const itemsByCategory = this.groupCartItemsByCategory(menuItems)
      const itemsByTableSeat = this.groupCartItemsByTableSeat(menuItems)
      itemsByTableSeat.forEach(tableSeat => {
        tableSeat.Items = this.groupCartItemsByCategory(tableSeat.Items)
      })
      data.ItemsFlat = menuItems
      data.ItemsByTableSeat = itemsByTableSeat
      data.Items = itemsByCategory

      this.removeWatchers()
      this.posCart.setData(data)
      this.addWatchers()

      this.cdsChannelMessageSend({
        Action : 'cart:data',
        Payload: this.posCart
      })
    },

    setLoaders(data) {
      const items = data?.Items || []
      items.forEach(item => {
        const cartItem = this.getCartItemByRowId(item.RowId)
        if (cartItem) {
          this.$set(item, 'Loading', cartItem?.Loading || false)
          this.$set(item, 'LoadingRemove', cartItem?.LoadingRemove || false)
          this.$set(item, 'LoadingCoupon', cartItem?.LoadingCoupon || false)
        }
      })

      const totals = data?.Totals || []
      totals.forEach(total => {
        const cartCoupon = this.getCartCouponByCode(total?.Code)
        if (cartCoupon) {
          this.$set(total, 'Loading', cartCoupon?.Loading || false)
        }

        const cartItem = this.getCartItemByRowId(cartCoupon?.RowId)
        if (cartItem) {
          this.$set(total, 'Loading', cartItem?.Loading || false)
          this.$set(total, 'LoadingCoupon', cartItem?.Loading || false)
        }
      })

      return data
    },

    getCartItemByRowId(rowId) {
      if (!rowId) return null
      const categories = this.posCart?.Items || []
      let retVal = null

      categories.forEach(category => {
        const menuItems = category?.Items || []
        menuItems.forEach(menuItem => {
          if (menuItem.RowId === rowId) retVal = menuItem
        })
      })

      return retVal
    },

    getCartCouponByCode(code) {
      if (!code) return null
      const totals = this.posCart?.Totals || []
      let retVal = null

      totals.forEach(total => {
        if (total?.Code === code) retVal = total
      })

      return retVal
    },

    getMenuItemSelectedOptionValueIds(menu) {
      const optionValuesIds = []

      if (!menu) return optionValuesIds

      const menuOptions = menu?.Details?.Options || []
      menuOptions.forEach(option => {
        const menuOptionValues = option?.OptionValues || []
        menuOptionValues.forEach(optionValue => {
          if (optionValue.Selected) optionValuesIds.push(parseInt(optionValue.Id))
        })
      })

      return optionValuesIds
    },

    checkForCustomerAddress() {
      if (this.posCart.Customer) {
        if (this.posCart.OrderType === 1) {
          if (this.posCart.Customer.Addresses.length <= 0) {
            this.$bus.$emit('show-customer-add-edit-address-dialog')
          } else if (this.posCart.Customer.Addresses.length === 1) {
            this.posCart.Address = this.posCart.Customer.Addresses[0]
          } else {
            this.posCart.Address = this.posCart.Customer.Addresses.find(addr => parseInt(addr.Id) === parseInt(this.posCart.Address?.Id)) || null
            if (!this.posCart.Address) this.$bus.$emit('cart:show-customer-select-address-dialog')
          }
        } else {
          this.posCart.AddressId = -1
          this.posCart.Address = null
        }
      }
    },

    clearData() {
      this.routeNext = null
      this.isOrderComplete = false
      this.isCartInitialized = false
      this.isFromCancelOrderButton = false

      this.removeWatchers()

      this.promiseQueue.clear()
      this.posCart.reset()
    },

    cdsChannelMessageSend({Action, Payload}) {
      if (!this.cdsChannel || this.isTableOrder) return

      try {
        this.cdsChannel.postMessage({
          Action : Action,
          Payload: Payload
        })
      } catch (error) {
      }
    },

    cdsChannelMessageReceived(event) {
      if (event?.data === 'close') {
        this.cdsChannel.close()
        return
      }

      const action = event?.data?.Action || null
      // const payload = event?.data?.Payload || null

      if (action === 'cart:get-data') {
        this.cdsChannelMessageSend({
          Action : 'cart:data',
          Payload: this.posCart
        })
      }
    },

    addWatchers() {
      this.watch('posCart.PaymentType', () => this.cartUpdate('orderPayment'))
      this.watch('posCart.SourceTypeId', () => this.cartUpdate('selectedOrderSourceType'))
      this.watch('posCart.CustomerId', () => {
        this.checkForCustomerAddress()
        this.cartUpdate('selectedCustomer')
      })
      this.watch('posCart.AddressId', () => this.cartUpdate('selectedAddress'))
      this.watch('posCart.OrderType', () => {
        this.checkForCustomerAddress()
        this.cartUpdate('orderTypeTime')
      })
    },
    removeWatchers() {
      this.unwatch('posCart.PaymentType')
      this.unwatch('posCart.SourceTypeId')
      this.unwatch('posCart.CustomerId')
      this.unwatch('posCart.AddressId')
      this.unwatch('posCart.OrderType')
    }
  }
}
